module.exports = __webpack_public_path__ + "img/smjh-head-img.7acd3950.png";